// @flow

import querystring from 'querystring';

import type { OnEnter } from 'app/common/types';

const routes = {
  '/app/contact-us': {
    fetch: () =>
      import(
        /* webpackChunkName: 'contact-route' */ 'app/contact-us/asyncRoute'
      ).then(module => module.default),
  },
  '/app/contact': {
    onEnter({
      routeTo,
      router: {
        next: { query },
      },
    }: OnEnter) {
      const qs = querystring.stringify(query);
      routeTo(`/app/contact-us${qs ? `?${qs}` : ''}`);
    },
  },
};

export default routes;
